module.exports = __webpack_public_path__ + "static/media/user-name-delete.8f7f14a3.svg";